import React from 'react';
import styled from 'styled-components';
import Title from './Title';

const Container = styled.section`
    grid-row: 5;
    grid-column: 1;
`;

const Link = styled.div`
    display: flex;
    align-items: center;
    margin-top: 2rem;
    font-size: clamp(1rem, 1.2vw + 0.4rem, 1.5rem);

    a {
        align-self: center;
        margin-left: 0.7rem;
        color: #a1a1a1;
        text-decoration: none;

        &:hover {
            color: #ffffff;
        }
    }

    p {
        align-self: center;
        margin: 0 0 0 0.7rem;
    }
`;

const Icon = styled.img`
    height: clamp(1.4rem, 2vw, 2rem);
    width: auto;
    flex-shrink: 0;
`;

const Links = () => {
    return (
        <Container id='links'>
            {Title('05', 'LINKS')}
            <Link>
                <Icon
                    src={process.env.PUBLIC_URL + '/img/Telegram.svg'}
                    alt='Telegram'
                />
                <a href='https:\\t.me/de4nny'>@de4nny</a>
            </Link>
            <Link>
                <Icon
                    src={process.env.PUBLIC_URL + '/img/Github.svg'}
                    alt='Github'
                />
                <a href='https:\\github.com/sirsur'>@sirsur</a>
            </Link>
            <Link>
                <Icon
                    src={process.env.PUBLIC_URL + '/img/Instagram.svg'}
                    alt='Instagram'
                />
                <a href='https:\\instagram.com/ynnaedgnikcuf'>@ynnaedgnikcuf</a>
            </Link>
            <Link>
                <Icon
                    src={process.env.PUBLIC_URL + '/img/Mail.svg'}
                    alt='Mail'
                />
                <p style={{ margin: '0 0 0 0.7rem' }}>
                    casimowa.c2001
                    <br />
                    @gmail.com
                </p>
            </Link>
        </Container>
    );
};

export default Links;
